
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const LightPage = lazy(() => import('../pages/light/page'));
const EditorPage = lazy(() => import('../pages/editor/page'));
const LandingPage = lazy(() => import('../pages/landing/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <LandingPage />,
  },
  {
    path: '/producer',
    element: <HomePage />,
  },
  {
    path: '/light',
    element: <LightPage />,
  },
  {
    path: '/editor',
    element: <EditorPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
